import { getVm } from '@/helpers/vm-helper';
import { TitleListName } from '@/interfaces/responses/title-list';
import { ObjectType } from '@/@types/graphql-types';
import { TitleContentType } from '@/interfaces/snowplow/title-context';

type TitleQuickActionPayload = {
	type: Exclude<TitleListName, TitleListName.MORELIST>;
	isTitleInList: boolean;
	titleObjectId: number;
	objectType: ObjectType;
};

export type ListMutationTitleDetailParam = {
	objectType: ObjectType;
	objectId: number;
	title: string;
	seasonNumber?: number;
	episodeNumber?: number;
	contentType?: TitleContentType;
};

export type ListMutationShowDetailParam = {
	showObjectId?: number;
};

export function emitTitleQuickActionEvent(payload: TitleQuickActionPayload) {
	getVm().$root.$emit('title-quick-action', payload);
}

export function onTitleQuickActionEventHandler(callback: (payload: TitleQuickActionPayload) => void) {
	getVm().$root.$on('title-quick-action', (payload: TitleQuickActionPayload) => callback(payload));
}
